import Offer from '@/models/Offer'
import User, { hasRole, Role } from '@/models/User'

export default class OfferPolicy {
    viewAny(_user: User) {
        return true
    }

    view(user: User, offer: Offer) {
        //return hasRole(user, Role.BROKER) || hasRole(user, Role.USER) && offer.company.id === user.company?.id
        switch (user.role) {
            case Role.BROKER:
                return true
            case Role.USER:
                return offer.company.id === user.company?.id
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.BROKER)
    }

    update(user: User, offer: Offer) {
        return hasRole(user, Role.BROKER) && offer.broker.id === user.broker?.id && (!offer.accepted_at || !offer.paid_at)
    }

    restore(_user: User, _offer: Offer) {
        return false
    }

    delete(user: User, offer: Offer) {
        return hasRole(user, Role.BROKER) && offer.broker.id === user.broker?.id && (!offer.accepted_at || !offer.paid_at)
    }

    forceDelete(_user: User, _offer: Offer) {
        return false
    }

    accept(user: User, offer: Offer) {
        return hasRole(user, Role.BROKER) && offer.sale.broker.id === user.broker?.id
    }

    pay(user: User, offer: Offer) {
        return hasRole(user, Role.USER) && offer.company.id === user.company?.id
    }
}
